import { useMemo } from "react";


interface IFeaturedIconV2Props {
  name: string;
  className?: string;
  iconClassName?: string;
}

export const FeaturedIconV2 = ({
  name = "",
  className = "",
  iconClassName = "",
}: IFeaturedIconV2Props) => {
  const iconUrl = useMemo(() => {
    return require(`../assets/images/v2/featured-icons/${name}.png`)
  }, [name])
  return (
    <div className={`${className}`}>
      <img
        className={`${iconClassName}`}
        src={iconUrl}
      />
    </div>
  );
};
